"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PaymentServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
class PaymentServiceLive {
    async getPlanInfo(planName, tierName) {
        const response = await HttpProvider_1.httpProvider.get(`/payment/plan-info/${planName}/${tierName}`);
        return response.data;
    }
    async getSubscriptionPlans() {
        const response = await HttpProvider_1.httpProvider.get("/payment/plan-info");
        return response.data;
    }
}
exports.PaymentServiceLive = PaymentServiceLive;
//# sourceMappingURL=PaymentServiceLive.js.map